import {
  Add,
  ListSharp,
  ArrowBack,
  LocationOnOutlined,
  CardTravel,
  BorderAll,
  AppSettingsAlt,
  StickyNote2Outlined,
  Payment,
  AccountBalanceWalletOutlined,
  SettingsOutlined,
  CategoryOutlined,

  // SendTimeExtensionOutlined,
} from "@mui/icons-material";

import {
  URL_CONFIGURABLES,
  URL_ROLES,
  URL_MASTER_DATA,
  URL_DISTRICTS,
  URL_COUNTIES,
  URL_SUB_COUNTIES,
  URL_PARISHES,
  URL_VILLAGES,
  URL_PASSWORD_RESET,
  URL_SETTINGS,
  URL_RESET_PIN,
  URL_WORKFLOWS,
  URL_SCRUTINY_WORKFLOW,
  URL_LIQUIDATION_CONFIGURABLES,
  URL_USSD_CUSTOMER_TRANSACTIONS,
  URL_USSD_INPUT_LOGS,
  URL_SET_USSD_MERCHANT,
  URL_USSD_INCOMING_LOGS,
  URL_USSD_OUTGOING_LOGS,
  URL_USSD_CONFIGURABLES,
  URL_COMPOSITE_ITEMS,
  URL_USSD_SAFEGUARDS,
  URL_OUTGOING_REQUESTS,
  URL_INCOMING_REQUESTS,
  URL_TRANSACTION_LOGS,
  URL_CUSTOMER_DETAILS,
  URL_ERROR_LOGS,
  URL_MERCHANT_INDUSTRIES_CONFIGURABLES,
  URL_MERCHANT_BUSINESS_CONFIGURABLES,
} from "../utils/urls";
import {
  getForm,
  getRegister,
  itemExists,
  useGetUserPermissions,
} from "../utils/helpers";

import {
  AccessibilityOutline,
  BuildOutline,
  Heart,
  KeyOutline,
  LogOutOutline,
  NavigateOutline,
  PersonOutline,
  SettingsOutline,
} from "@raresail/react-ionicons";
import { CAN_ADMIN, CAN_AGENT, CAN_MERCHANT } from "../utils/constants";

import { useModals } from "../components/common/useModals";
// import { useModals } from "../components/common/useModals";

export const accountSettings = [
  {
    label: "Profile",
    icon: PersonOutline,
    to: URL_SETTINGS,
  },
  {
    label: "Change Password",
    icon: KeyOutline,
    to: getForm(URL_PASSWORD_RESET),
  },
  {
    label: "Logout",
    icon: LogOutOutline,
    to: "/logout",
  },
];

export const useSettings = () => {
  const permissions = useGetUserPermissions();
  // const { setDisbursementSettings } = useModals();
  const { setOpenUSSDHealthCheck, setOpenDisbursementHealthCheck } =
    useModals();
  return [
    {
      label: "Back To Dashboard",
      icon: <ArrowBack />,
      to: "/",
    },
    {
      label: "Account Settings",
      key: "default",
      icon: <SettingsOutline />,
      to: URL_SETTINGS,
      visible: true,
    },
    {
      label: "Reset Wallet Pin",
      // key: "default",
      icon: <SettingsOutline />,
      to: getForm(URL_RESET_PIN),
      visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT, CAN_AGENT]),
    },

    // ROLES
    {
      label: "System Roles",
      icon: <AccessibilityOutline />,
      // visible: permissions.includes(
      //   CAN_VIEW_SYSTEM_SETTINGS,
      //   CAN_EDIT_SYSTEM_SETTINGS
      // ),
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "New Role",
          icon: <Add />,
          to: getForm(URL_ROLES),
        },
        {
          label: "Roles Register",
          icon: <ListSharp />,
          to: getRegister(URL_ROLES),
        },
      ],
    },

    // Configurables
    {
      label: "Configurations",
      icon: <BuildOutline />,
      // visible:
      // hasConfigurablesPermissions ||
      // permissions.includes(CAN_MANAGE_CHARTS_OF_ACCOUNTS),
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "Create Configuration",
          icon: <Add />,
          to: getForm(URL_CONFIGURABLES),
          // visible: hasConfigurablesPermissions,
        },
        {
          label: "All Configurations",
          icon: <BuildOutline />,
          to: getRegister(URL_CONFIGURABLES),
          // visible: hasConfigurablesPermissions,
        },
        {
          label: "Liquidations",
          icon: <CardTravel />,
          to: getRegister(URL_LIQUIDATION_CONFIGURABLES),
        },
        {
          label: "Merchant Configurables",
          icon: <SettingsOutlined />,
          visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
          children: [
            {
              label: "Add Industry",
              icon: <Add />,
              to: getForm(URL_MERCHANT_INDUSTRIES_CONFIGURABLES),
              visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
            },
            {
              label: "Industries",
              icon: <CategoryOutlined />,
              to: getRegister(URL_MERCHANT_INDUSTRIES_CONFIGURABLES),
              visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
            },

            {
              label: "Add Business Classification",
              icon: <Add />,
              to: getForm(URL_MERCHANT_BUSINESS_CONFIGURABLES),
              visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
            },
            {
              label: "Business Classifications",
              icon: <CategoryOutlined />,
              to: getRegister(URL_MERCHANT_BUSINESS_CONFIGURABLES),
              visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
            },
          ],
        },
      ],
    },

    // Composite items
    {
      label: "Composite Items",
      icon: <Payment />,
      // visible:
      // hasConfigurablesPermissions ||
      // permissions.includes(CAN_MANAGE_CHARTS_OF_ACCOUNTS),
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "Create Composite Item",
          icon: <Add />,
          to: getForm(URL_COMPOSITE_ITEMS),
          // visible: hasConfigurablesPermissions,
        },
        {
          label: "All Composite Items",
          icon: <Payment />,
          to: getRegister(URL_COMPOSITE_ITEMS),
          // visible: hasConfigurablesPermissions,
        },
      ],
    },
    {
      label: "USSD Services",
      icon: <AccessibilityOutline />,
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "New USSD Merchant",
          icon: <Add />,
          to: getForm(URL_SET_USSD_MERCHANT),
        },
        {
          label: "USSD Configurables",
          icon: <Add />,
          to: getForm(URL_USSD_CONFIGURABLES),
        },
        {
          label: "USSD Input Logs",
          icon: <ListSharp />,
          to: URL_USSD_INPUT_LOGS,
        },
        {
          label: "USSD Customer Transactions",
          icon: <ListSharp />,
          to: getRegister(URL_USSD_CUSTOMER_TRANSACTIONS),
        },
        {
          label: "USSD Incoming Logs",
          icon: <StickyNote2Outlined />,
          to: getRegister(URL_USSD_INCOMING_LOGS),
        },
        {
          label: "USSD Outgoing Logs",
          icon: <StickyNote2Outlined />,
          to: getRegister(URL_USSD_OUTGOING_LOGS),
        },
        {
          label: "USSD Service Health Check",
          icon: <Heart />,
          click: () => {
            setOpenUSSDHealthCheck();
          },
        },
        {
          label: "USSD Safeguards",
          icon: <StickyNote2Outlined />,
          to: getRegister(URL_USSD_SAFEGUARDS),
        },
      ],
    },

    // Disbursement Services
    {
      label: "Disbursement Services",
      icon: <AccountBalanceWalletOutlined />,
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "Outgoing Requests",
          icon: <AccountBalanceWalletOutlined />,
          to: getRegister(URL_OUTGOING_REQUESTS),
        },
        {
          label: "Incoming Requests",
          icon: <AccountBalanceWalletOutlined />,
          to: getRegister(URL_INCOMING_REQUESTS),
        },
        {
          label: "Transaction Logs",
          icon: <AccountBalanceWalletOutlined />,
          to: getRegister(URL_TRANSACTION_LOGS),
        },
        {
          label: "Customer Details",
          icon: <AccountBalanceWalletOutlined />,
          to: getRegister(URL_CUSTOMER_DETAILS),
        },
        {
          label: "Error Logs",
          icon: <AccountBalanceWalletOutlined />,
          to: getRegister(URL_ERROR_LOGS),
        },
        {
          label: "Disbursement Service Health Check",
          icon: <Heart />,
          click: () => {
            setOpenDisbursementHealthCheck();
          },
        },
      ],
    },

    //Workflows
    {
      label: "Workflows",
      icon: <CardTravel />,
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "Create Workflow",
          icon: <CardTravel />,
          to: getRegister(URL_WORKFLOWS),
        },
        {
          label: "Scrutiny Workflow Configuration",
          icon: <BorderAll />,
          to: getRegister(URL_SCRUTINY_WORKFLOW),
        },
      ],
    },
    {
      label: "App Integration",
      icon: <AppSettingsAlt />,
      to: "/api-integration/create",
      visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
    },
    // {
    //   label: "Disbursement",
    //   icon: <SendTimeExtensionOutlined />,
    //   click: () => {
    //     setDisbursementSettings();
    //   },
    //   visible: itemExists(permissions, [CAN_ADMIN, CAN_MERCHANT]),
    // },
    {
      label: "Master Data",
      icon: <NavigateOutline />,
      // visible: permissions.includes(
      //   CAN_VIEW_SYSTEM_SETTINGS,
      //   CAN_EDIT_SYSTEM_SETTINGS
      // ),
      visible: itemExists(permissions, [CAN_ADMIN]),
      children: [
        {
          label: "Add Master Data",
          icon: <Add />,
          visible: true,
          to: getForm(URL_MASTER_DATA),
        },
        {
          label: "Districts",
          icon: <LocationOnOutlined />,
          to: getRegister(URL_DISTRICTS),
        },
        {
          label: "Counties",
          icon: <LocationOnOutlined />,
          to: getRegister(URL_COUNTIES),
        },
        {
          label: "SubCounties",
          icon: <LocationOnOutlined />,
          to: getRegister(URL_SUB_COUNTIES),
        },
        {
          label: "Parishes",
          icon: <LocationOnOutlined />,
          to: getRegister(URL_PARISHES),
        },
        {
          label: "Villages",
          icon: <LocationOnOutlined />,
          to: getRegister(URL_VILLAGES),
        },
      ],
    },
  ];
};
